import { useMutation } from '@tanstack/react-query';

import { Place } from 'model/Place';
import Statistic from 'model/Statistic';
import { User } from 'model/User';

import { BaseResp } from './BaseResp';
import { client } from './client';

export type Account = {
  account: string;
  passwd: string;
};

interface SignInResp extends BaseResp {
  info: User;
  customerId: number;
}

interface DashboardResp extends BaseResp {
  areas: Place[];
  statistics: Statistic;
}

const signIn = (account: Account): Promise<SignInResp> => client.post('/account/login', { ...account });
export const useSignInMutation = () => useMutation({ mutationFn: signIn });

export const signOut = () => client.delete('account/logout');

export const checkPassword = (passwd: string): Promise<BaseResp> => client.get('account/pass', { params: { passwd } });
// export const useCheckPasswordMutation = () => useMutation({ mutationFn: checkPassword });

// home
export const getStatistic = (customerId: number): Promise<DashboardResp> => client.get('home/statistics', { params: customerId });
export const getDashboard = (customerId: number): Promise<DashboardResp> => client.get('home/dashboard', { params: customerId });